import config from '@app/config';
import { Ads } from './ads';

const { baseImageUrl } = config;

const ads: Ads[] = [
  {
    href: 'hakka-green-3-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-HAKKA-GREEN-3-AUTOGRAPH-ECO-3_1140х60.jpg`,
        imageMobile: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-HAKKA-GREEN-3-AUTOGRAPH-ECO-3_634х88.jpg`,
        href: '/catalog/tyres/ikontyres/autograph-eco-3-11649/',
        options: {
          heightMobile: 130,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakka-blue-3-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2937.jpg`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2936.jpg`,
        href: '/catalog/tyres/ikontyres/autograph-aqua-3-11649/',
        options: {
          heightMobile: 130,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakka-blue-3-suv-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-HAKKA-BLUE-3-SUV-AUTOGRAPH-AQUA-3-SUV_1140х60.jpg`,
        imageMobile: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-HAKKA-BLUE-3SUV-AUTOGRAPH-AQUA-3SUV_1140х60_634х88.jpg`,
        href: '/catalog/tyres/ikontyres/autograph-aqua-3-suv-11649/',
        options: {
          heightMobile: 130,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakka-black-2-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-HAKKA-BLACK-2-AUTOGRAPH-ULTRA-2_1140х60.jpg`,
        imageMobile: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-HAKKA-BLACK-2-AUTOGRAPH-ULTRA-2_634х117.jpg`,
        href: '/catalog/tyres/ikontyres/autograph-ultra-2-11649/',
        options: {
          heightMobile: 130,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakka-black-2-suv-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-HAKKA-BLACK-2-SUV-AUTOGRAPH-ULTRA-2-SUV_1140х60.jpg`,
        imageMobile: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-HAKKA-BLACK-2-SUV-AUTOGRAPH-ULTRA-2-SUV_634х114.jpg`,
        href: '/catalog/tyres/ikontyres/autograph-ultra-2-suv-11649/',
        options: {
          heightMobile: 130,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakka-van-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-HAKKA-VAN-AUTOGRAPH-ECO-C3_1140х60.jpg`,
        imageMobile: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-HAKKA-VAN-AUTOGRAPH-ECO-C3_634х114.jpg`,
        href: '/catalog/tyres/ikontyres/autograph-eco-c3-11649/',
        options: {
          heightMobile: 130,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'nordman-sx3-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-NOKIAN-NORDMAN-SX3-IKON-NORDMAN-SX3_1140х60.jpg`,
        imageMobile: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-NOKIAN-NORDMAN-SX3-IKON-NORDMAN-SX3_634х114.jpg`,
        href: '/catalog/tyres/ikontyres/nordman-sx3-11649/',
        options: {
          heightMobile: 130,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'nordman-s2-suv-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-NOKIAN-NORDMAN-S2-SUV-IKON-NORDMAN-S2-SUV_1140х60.jpg`,
        imageMobile: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-NOKIAN-NORDMAN-S2-SUV-IKON-NORDMAN-S2-SUV_634х114.jpg`,
        href: '/catalog/tyres/ikontyres/nordman-s2-suv-11649/',
        options: {
          heightMobile: 130,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'nordman-sz2-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-NOKIAN-NORDMAN-SZ2-IKON-NORDMAN-SZ2_1140х60.jpg`,
        imageMobile: `${baseImageUrl}/articles/wp-content/uploads/2024/03/Новое-имя-NOKIAN-NORDMAN-SZ2-IKON-NORDMAN-SZ2_634х114.jpg`,
        href: '/catalog/tyres/ikontyres/nordman-sz2-11649/',
        options: {
          heightMobile: 114,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakkapeliitta-9-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2990.jpg`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2991.jpg`,
        href: '/catalog/tyres/ikontyres/ikon-autograph-ice-9-11750/',
        options: {
          heightMobile: 114,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakkapeliitta-9-suv-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2992.jpg`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2993.jpg`,
        href: '/catalog/tyres/ikontyres/ikon-autograph-ice-9-suv-11750/',
        options: {
          heightMobile: 114,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakkapeliitta-r3-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2996.jpg`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2997.jpg`,
        href: '/catalog/tyres/ikontyres/ikon-autograph-snow-3-11750/',
        options: {
          heightMobile: 114,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakkapeliitta-r3-suv-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2998.jpg`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2999.jpg`,
        href: '/catalog/tyres/ikontyres/ikon-autograph-snow-3-suv-11739/',
        options: {
          heightMobile: 114,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakkapeliitta-c3-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2994.jpg`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2995.jpg`,
        href: '/catalog/tyres/ikontyres/ikon-autograph-ice-c3/',
        options: {
          heightMobile: 114,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakkapeliitta-cr3-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2986.jpg`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2987.jpg`,
        href: '/catalog/tyres/ikontyres/ikon-autograph-snow-c3-11750/',
        options: {
          heightMobile: 114,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
  {
    href: 'hakkapeliitta-lt3-114',
    banners: [
      {
        imageDesktop: `${baseImageUrl}/upload/medialibrary/banners/13_2988.jpg`,
        imageMobile: `${baseImageUrl}/upload/medialibrary/banners/13_2989.jpg`,
        handlerAction: () => undefined,
        options: {
          heightMobile: 114,
          widthMobile: 634,
          heightDesktop: 60,
          widthDesktop: 1140,
        },
      },
    ],
  },
];

export default ads;
